import { connect } from 'react-redux';

import RelatedItems from '../../components/metadata/relateditems';
import { removeRelatedThumbnail } from '../../actions/media';

const mapStateToProps = function(state) {
	return {
		visible: state.media.related ? state.media.related.items.length > 0 : false,
		items: state.media.related ? state.media.related.items : []
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		removeRelatedThumbnail: (index)=>dispatch(removeRelatedThumbnail(index))
	};
}

const RelatedItemsContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(RelatedItems)

export default RelatedItemsContainer;